import { get, ref, remove, set } from "firebase/database";
import { db } from "../lib/firebase";
import { getPathDatabaseByRole } from "./auth";
import { LaunchError } from "../utils/errors";
import {
  pickPlatformDefaultsLoadData,
  pickPlatformDefaultsPayload,
} from "../utils/platformDefaults/platformDefaultsSavedFields";

const getAdvertiserDefaultPlatformValuesPath = ({ advertiserID, platform }) =>
  `advertisersDefaultPlatformValues/${advertiserID}/${platform}`;

export const startGetAdvertiserDefaultPlatformValues =
  ({ platform }) =>
  async (dispatch) => {
    try {
      const { userID } = dispatch(getPathDatabaseByRole());
      const path = getAdvertiserDefaultPlatformValuesPath({
        advertiserID: userID,
        platform,
      });
      const snapshot = await get(ref(db, path));

      if (!snapshot.exists()) {
        return { ok: true, data: null };
      }

      const data = pickPlatformDefaultsLoadData({
        data: snapshot.val() || {},
      });

      return { ok: true, data };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startGetAdvertiserDefaultPlatformValues",
          context: { platform },
          tags: { action: "getAdvertiserDefaultPlatformValues" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };

export const startSaveAdvertiserDefaultPlatformValues =
  ({ platform, values }) =>
  async (dispatch) => {
    try {
      const { userID } = dispatch(getPathDatabaseByRole());
      const path = getAdvertiserDefaultPlatformValuesPath({
        advertiserID: userID,
        platform,
      });
      const payload = pickPlatformDefaultsPayload({
        candidate: values,
      });

      await set(ref(db, path), payload);
      return { ok: true };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startSaveAdvertiserDefaultPlatformValues",
          context: { platform },
          tags: { action: "saveAdvertiserDefaultPlatformValues" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };

const isSameIntegrationID = (left, right) => {
  if (left == null || right == null || left === "" || right === "") {
    return false;
  }

  return String(left) === String(right);
};

export const startClearAdvertiserDefaultPlatformValuesIfMatchingIntegration =
  ({ platform, integrationID }) =>
  async (dispatch) => {
    try {
      if (!integrationID || !platform) {
        return { ok: true, deleted: false };
      }

      const { userID } = dispatch(getPathDatabaseByRole());
      const path = getAdvertiserDefaultPlatformValuesPath({
        advertiserID: userID,
        platform,
      });
      const snapshot = await get(ref(db, path));

      if (!snapshot.exists()) {
        return { ok: true, deleted: false };
      }

      const data = snapshot.val() || {};

      if (!isSameIntegrationID(data.integrationID, integrationID)) {
        return { ok: true, deleted: false };
      }

      await remove(ref(db, path));
      return { ok: true, deleted: true };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName:
            "startClearAdvertiserDefaultPlatformValuesIfMatchingIntegration",
          context: { platform, integrationID },
          tags: { action: "clearAdvertiserDefaultPlatformValues" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };
